import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import { getColor } from 'common/constants/_colors';
import { Flex } from './base/layout-components';
import { Checkbox } from '@linearb/linui-common';

const Box = styled.div`
  ${({ notActive }) =>
    `border: 1px solid ${getColor(notActive ? 'pastelPink' : 'botticelli')};`};
  border-radius: 2px;
`;

export const BoxTitle = styled(Flex)`
  flex-grow: 1;
  padding: 1rem;
  cursor: pointer;
  color: ${getColor('shuttleGray')};
  ${({ notActive }) =>
    notActive
      ? `background-color: ${getColor('lavenderBlush')};`
      : `background-color: ${getColor('white')};`};
  align-items: center;
  ${({ isCollapsed, notActive }) =>
    isCollapsed
      ? `&:hover {
      background-color: ${getColor(notActive ? 'botticelli' : 'zircon')};
    }`
      : `
      border-bottom: 1px solid ${getColor('botticelli')};
    `};
`;

const ToggleCheckbox = ({ isChecked, onCheck }) => {
  return (
    <div
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <Checkbox value={isChecked} onChange={onCheck} />
    </div>
  );
};

const ToggleButton = styled.div`
  margin-right: 1rem;
  border: 1px solid ${getColor('nepal')};
  &:hover {
    border: 1px solid ${getColor('dodgerBlue')};
    ${({ notActive }) =>
      notActive ? `` : `background: ${getColor('zircon')};`};
    svg * {
      fill: ${getColor('dodgerBlue')};
    }
  }
`;

const toggleStyle = {
  color: `${getColor('nepal')}`,
  width: '1rem',
  height: '1rem',
  display: 'block'
};

const ToggleBox = ({
  collapsed,
  notActive,
  title,
  children,
  onClick = _.noop,
  isShowSingleToggleOpen = false,
  isControlled = false,
  isChecked,
  onCheck
}) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);
  const isCheckable = isChecked !== undefined && typeof onCheck === 'function';

  const isClose = isControlled ? collapsed : isCollapsed;

  useEffect(() => {
    if (isShowSingleToggleOpen) {
      setIsCollapsed(!isShowSingleToggleOpen);
    }
  }, [isShowSingleToggleOpen]);

  return (
    <Box notActive={notActive}>
      <BoxTitle
        notActive={notActive}
        onClick={() => {
          onClick();
          setIsCollapsed(!isCollapsed);
        }}
        isCollapsed={isClose}
      >
        {isCheckable && (
          <ToggleCheckbox isChecked={isChecked} onCheck={onCheck} />
        )}
        <ToggleButton notActive={notActive} data-cy='toggle-box-button'>
          {isClose ? (
            <Add style={toggleStyle} />
          ) : (
            <Remove style={toggleStyle} />
          )}
        </ToggleButton>
        {title}
      </BoxTitle>
      {!isClose && children}
    </Box>
  );
};

export default ToggleBox;
